'use strict';

var React = require('react');
var windowMessaging = require('../helpers/windowMessaging.js');
var PreviewSettingsContextProvider = require('../providers/PreviewSettingsContextProvider.js');

const usePreviewSettingsContext = () => {
    const previewSettingsContext = React.useContext(PreviewSettingsContextProvider.PreviewSettingsContext);
    const messageCMSClient = (action, data) => {
        windowMessaging.sendMessageToParent(previewSettingsContext.origin || '', action, data);
    };
    return {
        ...previewSettingsContext,
        messageCMSClient
    };
};

module.exports = usePreviewSettingsContext;
//# sourceMappingURL=usePreviewSettingsContext.js.map
